import src from "IMAGE";
export default { src, width: 284, height: 70, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAM0lEQVR42k3JMQoAIAxD0d5GEFzcFTcHHb3/VeIvdOjwEkhM0sPAREMNHcWIHefBTe37+rbQM7TbxeOsAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 2 }
